import axios from "axios";

function personInsert(objData) {
  return new Promise((resolve, reject) => {
    let port = ""
    if (process.env.ROOT_API.includes("viewmedonline"))
      port = ":3033"
    axios.post(process.env.ROOT_API + "/persons/insert", objData.person, {
      headers: {
        'Authorization': objData.token
      }
    }).then(result => {
      resolve(result.data.documents[0])
    }).catch(error => {
      reject(error)
    })
  })
}

function person_query(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3034";
      axios
        .put(process.env.ROOT_API + "/persons/query", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("Person_Query: ", error);
    }
  });
}

function prescriptiontInsert(objData) {
  return new Promise((resolve, reject) => {
    let port = ""
    if (process.env.ROOT_API.includes("viewmedonline"))
      port = ":3066"
    axios.post(process.env.ROOT_API + "/prescriptions/insert", objData.body, {
      headers: {
        'Authorization': objData.token
      }
    }).then(result => {
      resolve(result.data.documents[0])
    }).catch(error => {
      reject(error)
    })
  })
}

function prescriptionsUpdate(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = ""
      if (process.env.ROOT_API.includes("viewmedonline"))
        port = ":3074"
      axios.put(process.env.ROOT_API + "/prescriptions/update/" + objAux.prescriptionId, {
        headers: {
          'Authorization': objAux.token
        }
      }).then(result => {
        resolve(result.data.documents[0])
      }).catch(error => {
        reject(error.response.data.message)
      })
    } catch (error) {
      console.log(error)
    }
  })
}

function prescriptionsGet(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = ""
      if (process.env.ROOT_API.includes("viewmedonline"))
        port = ":3067"
      axios.get(process.env.ROOT_API + "/prescriptions/query/" + objAux.id, {
        headers: {
          'Authorization': objAux.token
        }
      }).then(result => {
        resolve(result.data.documents)
      }).catch(error => {
        reject(error.response.data.message)
      })
    } catch (error) {
      console.log(error)
    }
  })
}

function prescriptionsDelete(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = ""
      if (process.env.ROOT_API.includes("viewmedonline"))
        port = ":3088"
      axios.delete(process.env.ROOT_API + "/prescriptions/delete", {
        data: objAux.body,
        headers: {
          "Authorization": objAux.token
        }
      }).then(result => {
        resolve(result.data.documents)
      }).catch(error => {
        reject(error.response.data.message)
      })
    } catch (error) {
      console.log(error)
    }
  })
}

function treatmentInsert(objData) {
  return new Promise((resolve, reject) => {
    let port = ""
    if (process.env.ROOT_API.includes("viewmedonline"))
      port = ":3111"
    axios.post(process.env.ROOT_API + "/treatments/insert", objData.treatment, {
      headers: {
        'Authorization': objData.token
      }
    }).then(result => {
      resolve(result.data.documents[0])
    }).catch(error => {
      reject(error)
    })
  })
}

function treatmentGet(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = ""
      if (process.env.ROOT_API.includes("viewmedonline"))
        port = ":3112"
      axios.get(process.env.ROOT_API + "/treatments/query/" + objAux.user, {
        headers: {
          'Authorization': objAux.token
        }
      }).then(result => {
        resolve(result.data.documents)
      }).catch(error => {
        console.log("treatmentGet error Serv", error)
        reject(error.response.data.message)
      })
    } catch (error) {
      console.log(error)
    }
  })
}

function treatmentDelete(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = ""
      if (process.env.ROOT_API.includes("viewmedonline"))
        port = ":3114"
      axios.delete(process.env.ROOT_API + "/treatments/delete/" + objAux.idTreatment, {
        headers: {
          'Authorization': objAux.token
        }
      }).then(result => {
        resolve(result.data.documents)
      }).catch(error => {
        reject(error.response.data.message)
      })
    } catch (error) {
      console.log(error)
    }
  })
}

function treatmentUpdate(objData) {
  return new Promise((resolve, reject) => {
    let port = ""
    if (process.env.ROOT_API.includes("viewmedonline"))
      port = ":3113"
    axios.put(process.env.ROOT_API + "/treatments/update/" + objData.idTreatment, objData.body, {
      headers: {
        'Authorization': objData.token
      }
    }).then(result => {
      resolve(result)
    }).catch(error => {
      reject(error)
    })
  })
}

function getMedicinesQuery(objData) {
  return new Promise((resolve, reject) => {
    let port = ""
    if (process.env.ROOT_API.includes("viewmedonline"))
      port = ":3150"
    axios.post(process.env.ROOT_API + "/medicine/query", objData.body, {
      headers: {
        'Authorization': objData.token
      }
    }).then(result => {
      resolve(result.data.documents)
    }).catch(error => {
      reject(error)
    })
  })
}

function prescriptionPdf(objData) {
  return new Promise((resolve, reject) => {
    let port = ""
    if (process.env.ROOT_API.includes("viewmedonline"))
      port = ":3033"
    axios.get(process.env.ROOT_API + "/prescription/pdf/"+ objData.id+"/"+objData.lang, {
      responseType: "blob",
      headers: {
        "content-type": "multipart/form-data",
        Authorization: objData.token
      }
    }).then(result => {
      resolve(result)
    }).catch(error => {
      reject(error)
    })
  })
}

export {
  prescriptiontInsert,
  prescriptionsUpdate,
  prescriptionsGet,
  prescriptionsDelete,
  personInsert,
  treatmentInsert,
  treatmentGet,
  treatmentDelete,
  treatmentUpdate,
  getMedicinesQuery,
  person_query,
  prescriptionPdf
}



// WEBPACK FOOTER //
// ./src/components/prescription/prescriptionServ.js